import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

function ChartInscricoes({ inscritos = 0, vagas = 0 }) {
    const inscritosNum = Number(inscritos) || 0;
    const vagasNum = Number(vagas) || 0;
    const restantes = Math.max(0, vagasNum - inscritosNum);

    const data = [
        { name: 'Inscritos', value: inscritosNum, color: '#8AE600' },
        { name: 'Vagas Restantes', value: restantes, color: '#262B34' }
    ];

    return (
        <div className="w-full h-64 flex flex-col items-center justify-center">
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        innerRadius={55}
                        outerRadius={80}
                        paddingAngle={5}
                        dataKey="value"
                    >
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} stroke="#111317" strokeWidth={2} />
                        ))}
                    </Pie>
                    <Tooltip
                        contentStyle={{ backgroundColor: '#111317', borderColor: '#262B34', borderRadius: '8px', color: 'white' }}
                    />
                    <Legend verticalAlign="bottom" wrapperStyle={{ color: '#94A3B8', fontSize: '12px' }} />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
}

export default ChartInscricoes;